module.exports = __webpack_public_path__ + "static/media/Dr.-Mejor-(Retd.)-Anwar-Hussain.78eb69d2.png";